// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2A_J-","header":"PatientBlock_header__ZTpQ7","label":"PatientBlock_label__2TNM6","option":"PatientBlock_option__1RCYD"};